import { render, staticRenderFns } from "./Future.vue?vue&type=template&id=c23cc39a&scoped=true"
import script from "./Future.vue?vue&type=script&lang=js"
export * from "./Future.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23cc39a",
  null
  
)

export default component.exports